 // QUICK ADD TO CART CODE START

function addtocart_custom(){
var status = {
      loading: false
    };
  
     $(".quic-add-btn-main-wapper .product-single__form.quick_add_form").on("submit",function(evt){
         evt.preventDefault();
            // Loading indicator on add to cart button

       if (status.loading) {
          return;
        }
       status.loading = true;
       
         $(this).find('button.add-to-cart').addClass('btn--loading');
         
            var data = theme.utils.serialize(this);
           const $_this = $(this)
            fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: data,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                error(data,$_this);
              } else {
                var product = data;
                success(product,$_this);
              }
            })
    
         function success(product,form){
           // console.log(form);
           $('.product-single__form.quick_add_form .error')
           status.loading = false;
            form.find('button.add-to-cart').removeClass('btn--loading');
           // $('button.add-to-cart').removeClass('btn--loading');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this.addToCart
              }
            }));
         }
    
          function error(error,form) {
            status.loading = false;
             // $('button.add-to-cart').removeClass('btn--loading');
            form.find('button.add-to-cart').removeClass('btn--loading');
             console.log(error);
          }     
     });
}

  addtocart_custom();
 // QUICK ADD TO CART CODE END


// CUSTOM PAGINATION START VK

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
if(window.location.href.includes('?page=')){
window.location.replace(window.location.href.split('?')[0]);
}

function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace grid 
      // console.log(html.querySelector("[data-product-main-wrapper]").innerHTML);
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); 
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
      //  pagination_click_fun(); // reinit click event
      }
       theme.reinitProductGridItem(); //this is theme defualt function
        addtocart_custom(); //Add to cart collection function
    }
  });
}
// CUSTOM PAGINATION END VK


// cart Attr update.



  $(document).on('input', '#w_number', function(event) {
    var w_number_val = $(this).val();
      console.log(!/\D/g.test(w_number_val));
    if(!/\D/g.test(w_number_val)){
      $('#show_error').addClass('hide');
    if(w_number_val.length >= 7  ){
     cartattupdate(w_number_val);
     }else{
      cartattupdate(null);
    }
    }else{
      $('#show_error').removeClass('hide');
    }
});


let cartattupdate = (cart_attrt) => {
  var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({attributes: { 'Whatsapp Number': cart_attrt} })
    };
    fetch('/cart/update.js', request)
    .then(function() {
      // location.href = '/cart';
      // console.log("success:-attr");
    });
};
// cart attr update





// UPSELL PRODUCT ADD TO CART START

 $(document).on('click', '.quic-add-btn-main-wapper   .upsell_add_to_cart', function(event) {
      event.preventDefault();
            let arr = [];
            arr.push({id: $(this).data("pro-id"), quantity: 1 });   
            let formData = {'items': arr};
              fetch('/cart/add.js', {
                  body: JSON.stringify(formData),
                  credentials: 'same-origin',
                  headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
                  },
                  method: 'POST'
                })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                error(data,$_this);
              } else {
                 document.dispatchEvent(new CustomEvent('cart:build'));
                 document.dispatchEvent(new CustomEvent('cart:updated'));
              }
            })

});

// UPSELL PRODUCT ADD TO CART END


$('#event-filter').change(function(){ 
    console.log($(this).val());
            if(typeof $(this).val() === 'string'){
              $('.alpahirt-event .alpahirt-event-item').hide();
              $('.alpahirt-unterwegs-event-wrapper .alpahirt-current-date').text($(this).val().replace("-", " "));
               $('.alpahirt-event .alpahirt-event-item[data-select-value='+$(this).val()+']').show();
            }
         });



//PDP popup code
 $(document).on("click",".info-cart-pickup-popup-tragger",function(e){
            e.preventDefault();
                Swal.fire({
                  title: '<strong>Nur Abholung möglich</strong>',
                   imageUrl: 'https://cdn.shopify.com/s/files/1/0788/5720/8140/files/information-button.png?v=1705646240',
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'popup_logo',
                  color: '#453635',
                  html:
                    '<p style="text-align:left;"> Dieser Warenkorb enthält Produkte, die nur auf Abholung bestellt werden können. Um fortzufahren müssen die anderen Produkte entfernt werden.</p>',
                  customClass: {
                                image: 'popup-image',
                                htmlContainer: 'popup-text',
                                confirmButton: 'popup-button btn',
                              },
                   allowOutsideClick: false,
                  allowEscapeKey: false,
                  confirmButtonColor: '#4251bb',
                  showCloseButton: true,
                  showCancelButton: false,
                  focusConfirm: false,
                  confirmButtonText:
                    'Habe ich verstanden'
                }).then((result) => {
                    if (result.isConfirmed) {
                      // $("button[name='checkout']").click();
                      // $('.site-nav__icons .cart-total_price.small--hide').trigger('click');
                    }
                  })
          });



     $(document).on("click",".tag_info_show",function(e){
    $(this).toggleClass('this_active');
    if($(this).hasClass('this_active')){
        $(this).find('.text_load-more').text('Weniger anzeigen');
    }else{
       $(this).find('.text_load-more').text('Mehr erfahren');
    }
   $(this).parent('.right').toggleClass('active'); 

    
});


$(document).on("click",".tabbedPanels .tab-text-inner .tab-btn a.btn-link",function(event){
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VZTrjr']);
});



// $(document).on("click",".product-single__form .js-qty__adjust",function(e){
//   e.preventDefault();
//   var qty = parseInt($(this).closest('.js-qty__wrapper').find('.js-qty__num').val());
//   if($(this).hasClass("js-qty__adjust--plus")){
//           $(this).closest('.js-qty__wrapper').find('.js-qty__num').val(qty+1).change();
//   }else{
//       var newQty = ( qty > 1) ? (qty - 1) : 1;
//       $(this).closest('.js-qty__wrapper').find('.js-qty__num').val(newQty).change();
//   }
// });

//20-09-2024  lang select change code
$('.announcement-bar .announcement-link-right #LocalizationSelector').change(function(){
  $('.announcement-bar .announcement-link-right .Local_lang_switcher .localization-form button.LocalizationSubmit').trigger('click')
});
$('.Local_lang_switcher.mobile-switcher .localization-form #LocalizationSelectorMobile').change(function(){
  $('.Local_lang_switcher.mobile-switcher .localization-form button.LocalizationSubmit').trigger('click')
});






// for style sticky table item : 

  document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".sticky-filter-table a");

    links.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Remove active from all
        links.forEach((el) => el.classList.remove("active"));

        // Add to current
        this.classList.add("active");

        // Scroll smoothly to section
        const targetId = this.getAttribute("href").substring(1);
        const targetEl = document.getElementById(targetId);
        const offset = 100; // adjust if you have sticky header

        if (targetEl) {
          const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });
        }
      });
    });
  });


